export default function numberWithCommas(num) {
  if (!num) return num;
  return parseInt(num, 10).toLocaleString();
}
